import { action, message, redirect } from "./globals";

export function setMessage (key, value) {
    if(value !== null) message[key] = value;
}

export function setRedirect (status, url) {
    if(url !== null) redirect[status] = url;
}

export function setAction (events, fn) {
    if(events.constructor !== Array) events = [events];

    let event;
    for(let i = 0, len = events.length; i < len; i++){
        event = events[i];
        action[event] = fn;
    }
}